﻿import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators';
import checkoutService from '../../api/checkout';

export default {
    name: 'choose-prefered-payment-method',
	template: '#choose-prefered-payment-method-template',
    mounted() {

        this.$watch('$v.model.$invalid', () => {
            this.updateValidState(this.$v.model.$invalid);              
        });

        this.updateValidState(this.$v.model.$invalid);   
        this.model.selectedRecurringPaymentType = this.viewmodel.currentRecurringPaymentType;
        this.model.pbsAccountNumber = this.viewmodel.pbsAccountNumber;
        this.model.pbsRegNumber = this.viewmodel.pbsRegNumber;
        this.validateGiro()

        this.setPaymentType();
    },
	data: () => ({
		cartUpdateFailed: false,
		model: {
		    selectedRecurringPaymentType: '',
		    pbsRegNumber: '',
		    pbsAccountNumber: '',
		}
	}),
	props: ['viewmodel'],
	validations: function () {
	    var vals = {
	        model:{
	            selectedRecurringPaymentType: {
	                required
	            },
	            pbsRegNumber: {
	                numeric
	            },
	            pbsAccountNumber: {
	                numeric
	            }
	        }
	    };

	    if(this.viewmodel.isExistingCustomer == false){
	        vals.model.pbsRegNumber = {
	            required,
	            numeric,
	            minLength: minLength(4),
	            maxLength: maxLength(4)
	        };

	        vals.model.pbsAccountNumber = {
	            required,
	            numeric,
	            minLength: minLength(7),
	            maxLength: maxLength(10)
	        }
	    }

	    return vals;
	},
	methods: {
	    setPaymentType() {
	        this.validateGiro();
	    	const parameters = { 
	    	    recurringPaymentType: this.model.selectedRecurringPaymentType, 
	    		currentBlockId: this.viewmodel.blockId,
	    		pbsRegNumber: this.model.pbsRegNumber,
	    	    pbsAccountNumber: this.model.pbsAccountNumber,
	    	};

	        checkoutService.saveInfo(this.viewmodel.apiUrl,
	            parameters,
	            (data) => {
	            	this.cartUpdateFailed = !data.success;
	            	this.$store.dispatch('updateBasket');
	            },
	            () => { alert('failed to update fees'); }
	        );
	    },
        updateValidState(invalid){
            this.$store.dispatch('updateValidState', {invalid: invalid, blockId: this.viewmodel.blockId});   
	    },
        validateGiro(){
            var isInvalid = this.model.selectedRecurringPaymentType === 'Pbs' ? this.$v.model.$invalid : false;
            this.$store.dispatch('updateValidState', {invalid: isInvalid, blockId: this.viewmodel.blockId});   
        }
	}
}
